import {SalarieDto} from "../../data-access/http/dto/salarie.dto";
import {Salarie} from "../../../shared/models/salarie";

export class SalarieMapper {
  static dtoToModel(dto: SalarieDto): Salarie {
    return {
      ...dto,
      displayName: dto.prenom + ' ' + dto.nom
    }
  }
}
